module.exports = __webpack_public_path__ + "static/media/Euro-Tours-Screenshot.7032d3b6.png";